var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2746,
    height: 1084,
    viewBox: "0 0 2746 1084",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 157.595C228.833 429.454 614.036 892.437 1188.98 628.251C1448.32 462.39 1605.65 207.818 1948.9 275.568C2458.05 497.449 2459.96 511.126 2746 443.376V816.001H0V157.595Z",
    fill: "url(#paint0_linear_5_18)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 493.484C0 512.283 10.5437 529.497 27.2964 538.027C361.448 708.16 695.599 871.262 1029.75 769.066C1373 664.089 1487.42 419.14 1830.67 489.126C2167.78 557.859 2384.41 974.108 2727.14 713.978C2739.07 704.927 2746 690.404 2746 675.433V581.725V1034C2746 1061.61 2723.61 1084 2696 1084H50.0001C22.3858 1084 0 1061.61 0 1034L0 345.525L0 493.484Z",
    fill: "url(#paint1_linear_5_18)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_18",
    x1: -0.0000196502,
    y1: 228.127,
    x2: 274600,
    y2: 228.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#82B4FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B4FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_18",
    x1: 37.5,
    y1: 1039,
    x2: 274600,
    y2: 406.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00325493,
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FD1E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2746,
    height: 1084,
    rx: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/Wave.d76bcaef4a4f5d3ffafeb3b91a057b81.svg";
export { ForwardRef as ReactComponent };